export default "__VITE_ASSET__CbTngwLY__"